import React from "react";

import Layout from "../components/contactoLayout";

const Page = () => <Layout />;

export default Page;
